interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const ShareIcon = ({ width = 16, height = 16, color = '#6B5FC6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.72295 9.45337L9.16441 6.01132C9.39163 5.7841 9.761 5.7841 9.98822 6.01132C10.2154 6.23912 10.2154 6.60792 9.98822 6.83571L6.54676 10.2772L9.24831 15.3802C9.46621 15.7921 9.90957 16.0345 10.3739 15.996C10.8388 15.9576 11.2362 15.6459 11.3836 15.2031C12.409 12.1275 14.9806 4.41207 15.9401 1.53399C16.0794 1.11509 15.9704 0.65367 15.6587 0.341392C15.3465 0.0291151 14.885 -0.0798334 14.4661 0.0599923L0.796429 4.61656C0.354231 4.76396 0.0425315 5.16072 0.00349679 5.62564C-0.0349553 6.09056 0.207417 6.53334 0.619903 6.75182L5.72295 9.45337Z'
        fill={color}
      />
    </svg>
  );
};

export default ShareIcon;
